<template>
    <you-tube
        ref="youtube"
        class="trailer-player"
        :src="videoSrc"
        width="100%" 
        height="100%"
        :vars="vars"
        host="https://www.youtube.com"
        @state-change="stateСhange" 
        @error="error" 
        @ready="ready"
    />
    <you-tube-timer v-if="time > 0" :time="time" />
</template>

<script setup lang="ts">
    import YouTube, {type PlayerVars} from 'vue3-youtube';
    import { computed, onUnmounted, type Ref, ref } from 'vue';
    import YouTubeTimer from "./components/YouTubeTimer/YouTubeTimer.vue";

    const props = defineProps({
        videoId: {
            type: String,
            required: true
        },
    });

    const emit = defineEmits(['ended', 'error']);
    const youtube: Ref<YT.Player | null> = ref(null);
    const time: Ref<number> = ref(0);
    let timerDuration: ReturnType<typeof setInterval> | null = null;
    const vars: PlayerVars = {
        autoplay: 1,
        controls: 0,
        autohide: 0,
        disablekb: 1,
        fs: 0,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
        origin: window.location.origin,
    }
 
    const videoSrc = computed((): string => `https://www.youtube.com/embed/${props.videoId}`);
    
    const getDuration =  () => {
        timerDuration = setInterval(function() {
            time.value = youtube.value ? Math.floor(youtube.value.getDuration() - youtube.value.getCurrentTime()) : 0;
        }, 1000);
    };

    const ready = (event: YT.PlayerEvent) => {
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            const videoData = event.target.getVideoData();
            if(videoData.errorCode !== null || !('video_id' in videoData)) {
                error(event as YT.OnErrorEvent);
            }

            getDuration();
        } catch (e) {
            console.error('Error in YouTube player ready event:', e);
        }


    };

    const error = (event: YT.OnErrorEvent) => {
        emit('error', event);
    };

    const stateСhange = (event: YT.OnStateChangeEvent) => {
        // @ts-expect-error-verbatimModuleSyntax
        if (event.data === YT.PlayerState.ENDED) {
            emit('ended');
        }
    };

    onUnmounted(() => {
        if (timerDuration) {
            clearInterval(timerDuration);
        };
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>